export const defaultSelectedLoopKits = { global: ['default-loop-kit'] };
